import { render, staticRenderFns } from "./IssueDiscount.vue?vue&type=template&id=d81520ee&"
import script from "./IssueDiscount.vue?vue&type=script&lang=js&"
export * from "./IssueDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports